import { Buttons } from "@/ui/Buttons";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-6 py-lg-7",
  tagline,
  title,
  description,
  image,
  buttons,
  reverse = false,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div
      className={cn(className, classes.ContentSideImage)}
      data-reverse={reverse}
      data-bs-theme={theme}
    >
      <ParallaxBackground anim="y2n:x0:z1" image={bg_1} className={classes.bg_1} />
      {reverse && <ParallaxBackground anim="y1:x2:z0" image={bg_2} className={classes.bg_2} />}
      {reverse && (
        <ParallaxBackground
          anim="y2:x0:z0"
          image={bg_3}
          floating={false}
          className={classes.bg_3}
        />
      )}
      <Container fluid="lg">
        <Row className={cn({ "flex-row-reverse": !reverse })}>
          <Col xs={12} lg={8}>
            <div
              className={cn("px-4", {
                "ps-lg-0 pe-lg-6": reverse,
                "pe-lg-0 ps-lg-6": !reverse,
              })}
            >
              <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
                <span dangerouslySetInnerHTML={{ __html: tagline }} />
              </Tagline>
              <EditableText path="title" tag="h2" className="mb-4">
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </EditableText>
              <EditableHtml path="description">
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </EditableHtml>
              <Buttons buttons={buttons} className="justify-content-lg-start flex-row my-5" />
            </div>
          </Col>
          <Col xs={12} lg={4} className="position-relative">
            <ParallaxHexagon translateY={[0, 20]} className={classes.img}>
              <EditableImage path="image" src={image} size="372x319" alt="" />
            </ParallaxHexagon>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
